"use client"

import type React from "react"
import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { useSyncProgress } from "../../../hooks/useSyncProgress"
import { useLocalStorageCleanup } from "../../../hooks/useLocalStorageCleanup"
import { ROUTES } from "../../../constants/sync-progress"

// Components
import StepIndicator from "./StepIndicator"
import PlatformLogos from "./PlatformLogos"
// import ProgressIndicator from "./ProgressIndicator"
import CompletionMessage from "./CompletionMessage"
import ErrorSummary from "./ErrorSummary"
import ActionButtons from "./ActionButtons"

import "./SyncingProgress.css"

const SyncingProgressConnectScreen: React.FC = () => {
  const navigate = useNavigate()
  const { syncStatus } = useSyncProgress()
  const { cleanupFlowData } = useLocalStorageCleanup()

  const handleGoToHome = useCallback(() => {
    cleanupFlowData()
    navigate(ROUTES.DASHBOARD)
  }, [cleanupFlowData, navigate])

  const handleViewLogs = useCallback(() => {
    navigate(ROUTES.SYNC_LOGS)
  }, [navigate])

  const isAnimating = syncStatus.status === "syncing"

  return (
    <div className="syncing-progress">
      <div className="syncing-header">
        <h1>Connector Setup</h1>
        <StepIndicator />
      </div>

      <div className="syncing-animation">
        <PlatformLogos isAnimating={isAnimating} />

        {/* <ProgressIndicator syncStatus={syncStatus} /> */}

        <CompletionMessage syncStatus={syncStatus} />

        <ErrorSummary errors={syncStatus.errors} />
      </div>

      <div className="syncing-actions">
        <ActionButtons status={syncStatus.status} onGoToHome={handleGoToHome} onViewLogs={handleViewLogs} />
      </div>
    </div>
  )
}

export default SyncingProgressConnectScreen
